import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { GridModule } from "@progress/kendo-angular-grid";
import { ModalVehicleGestionFormModule } from "../../../../dms/modulos/general/componentes/gestion-terceros/modals/modal-vehicle.module";
import { OrdenReparacionModule } from "../../orden-reparacion/orden-reparacion.module";
import { TabVehiclesComponent } from "./tab-vehicles.component";

@NgModule({
    imports: [
        CommonModule,
        TranslateModule,
        GridModule,
        OrdenReparacionModule,
        ModalVehicleGestionFormModule
    ],
    declarations: [
        TabVehiclesComponent,
    ],
    exports: [
        TabVehiclesComponent,
    ]
})
export class TabVehiclesModule { }
